<bs-digital-summary [isTeaser]="true" [oddsDisplayFormat]="oddsDisplayFormat"> </bs-digital-summary>
